/**
 * Label resolution for BalanceCategory + BalanceDetail (DTO v2).
 *
 * Server emits labelI18n for catalog-known entries (category keys like
 * "economy.cat.legal_income", action details like "action.extort.label")
 * and falls back to a runtime label for items not in the catalog
 * (per-building, per-runner, per-contact rows where the name is a live
 * string). This helper resolves either case via i18n and hides the
 * fallback chain from every caller.
 */
import { t } from '../i18n';
import type { BalanceCategory, BalanceDetail } from '../data/fixture';

export function balanceCategoryLabel(cat: BalanceCategory): string {
  if (cat.labelI18n) {
    const resolved = t(cat.labelI18n);
    if (resolved !== cat.labelI18n) return resolved;
  }
  return cat.key;
}

export function balanceDetailLabel(d: BalanceDetail): string {
  if (d.label) return d.label;
  if (d.labelI18n) {
    const resolved = t(d.labelI18n);
    if (resolved !== d.labelI18n) return resolved;
  }
  return d.labelI18n ?? '';
}
